import { HttpContextToken } from '@angular/common/http';

/** Attach to requests that should silently handle 403 without triggering toasts or re-fetches. */
export const SKIP_FORBIDDEN_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false
);
